import { Component, inject, signal } from '@angular/core';
import { Navbar } from '../navbar/navbar';
import { Footer } from '../footer/footer';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { Api } from '../../services/api';
import { Canonical } from '../../services/canonical';
import { catchError, delay, of, tap, timeout } from 'rxjs';
import { CareerItems } from '../../interface/careers';
import { NgClass, TitleCasePipe } from '@angular/common';
import { TruncatePipe } from '../../pipes/truncate-pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-careers',
  imports: [
    Navbar,
    Footer,
    RouterLink,
    NgClass,
    NgxSkeletonLoaderModule,
    TitleCasePipe,
    TruncatePipe
  ],
  templateUrl: './careers.html',
  styleUrl: './careers.css',
})
export class Careers {
  title = inject(Title);
  meta = inject(Meta);
  isLoading = signal(false);
  careers = signal<CareerItems[]>([]);
  private api = inject(Api);
  private canonical = inject(Canonical);
  private http = inject(HttpClient);

  // private setMetaTags() : void {
  //   const title = `Careers - ${environment.appName}`;
  //   const url = `${environment.basePath}/careers`;
  //   this.title.setTitle(title);
  //   this.canonical.setCanonicalUrl(url);

  //   this.meta.addTags([
  //     {name: 'description', content: 'We are building and strenghtening the future of the Philippine pharmaceuticals'},
  //     {name: 'keywords', content: 'Careers in Bewell Corporation, Job openings in bewell, Medical Representative, Territory Sales Supervisor, Brand Ambassador, Operations Support Specialist, Tech Support'},
  //     {name: 'og:title', content: title},
  //     {name: 'og:description', content: 'We are building and strenghtening the future of the Philippine pharmaceuticals'},
  //     {name: 'og:type', content: 'website'},
  //     {name: 'og:url', content: url}
  //   ]);
  // }

  private initialize() : void {
    this.isLoading.set(true);

    this.api.getOptimizeCareers()
    .pipe(
      timeout(10000),
      catchError(() => of({
        canonical: null,
        title: null,
        meta: null,
        org: null
      }))
    ).subscribe(obj => {
      this.canonical.setCanonicalUrl(obj.canonical!);
      this.title.setTitle(obj.title!);
      this.meta.addTags(JSON.parse(obj.meta!));
    });

    this.api.getCareers()
   . pipe(
      timeout(10000),
      catchError(() => of([])),
      tap(() => this.isLoading.set(false))
    ).subscribe(careers => this.careers.set(careers));
  }

  request = toSignal(this.http.get<any>(`${environment.apiUrl}/careers`));

  ngOnInit() : void {
    this.initialize();
  }
}
